import { observer } from 'src/utils/mobx-react';
import Link from 'src/components/Link/Link';
import RoutedTabs from 'src/components/Tabs/Routed';
import React, { useState } from 'react';
import { EventsWrapper } from 'src/domains/sportsbook/trading/view/eventDetails/Events.style';
import { useAppStateContext } from 'src/AppState/AppState';
import { EventsState } from 'src/domains/sportsbook/trading/view/eventDetails/Events.state';
import { EventDetails } from 'src/domains/sportsbook/trading/view/eventDetails/EventDetails';

export const Events = observer('Events', () => {
    const appState = useAppStateContext();
    const [state] = useState(() => new EventsState(appState));
    const eventId = state.eventFromRoute;

    if (eventId === null) {
        return null;
    }

    const name = /*eventId === null ? 'events' :*/ 'events visible';

    const openedEvents = appState.sportsbookState.eventPageState.openedEvents;

    const renderEventDetails = (innerEventId: number): JSX.Element | null => {
        const event = appState.sdkStaff.models.getEvent(innerEventId);
        if (event === null) {
            return null;
        }
        return (
            <EventDetails
                data-test='event-details'
                eventId={event.id}
                key={event.id}
                label={event.name}
            />
        );
    };

    return (
        <EventsWrapper
            className={name}
            visible={state.isEventOpened}
        >
            <div
                className='events-content'
                data-test-event-id-content={eventId}
            >
                <Link
                    route='events'
                    className='events-minimize'
                    onClick={(): void => state.onRememberLastTab(eventId)}
                />
                <RoutedTabs
                    namespace='events'
                    className='tabs__vertical tabs__events'
                    onClose={state.onCloseHandler}
                    allowNoActive={true}
                    allowClose={true}
                    onChange={state.onChangeEventTab}
                >
                    {openedEvents.length > 0
                        ? openedEvents.map((innerEventId) => renderEventDetails(innerEventId))
                        : renderEventDetails(eventId)}
                </RoutedTabs>
            </div>
        </EventsWrapper>
    );
});
